import { formatRoute } from 'react-router-named-routes';

import axios from '../config/axios';
import * as actionTypes from '../config/actionTypes';
import * as routes from '../config/routes';
import * as constants from '../config/constants';

import {
  getAuthHeaders,
  manageAuthActionError,
  storeUserData,
  storeAuthData,
} from '../auth/actions';
import {
  checkValidity,
  changeInputHandler,
  handleFormSubmit,
  updateFieldErrorsHandler,
} from '../common/utility';


export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_PROFILE_LOADING,
  };
};


export const toggleError = () => {
  return {
    type: actionTypes.TOGGLE_PROFILE_ERROR,
  };
};


export const updateProfileInputs = (section, data) => {
  return {
    type: actionTypes.UPDATE_PROFILE_INPUTS,
    payload: { section: section, data: data }  // eslint-disable-line
  };
};

export const updateBranchFieldStatus = (value) => {
  return {
    type: actionTypes.UPDATE_BRANCH_FIELD_STATUS,
    payload: { value },
  };
};

export const updateFieldErrors = (section, inputs, errorData) => {
  return (dispatch) => {
    const updatedInputs = updateFieldErrorsHandler(inputs, errorData);
    dispatch(updateProfileInputs(section, updatedInputs));
  };
};


export const updateNonFieldErrors = (errorData) => {
  return {
    type: actionTypes.UPDATE_PROFILE_ERRORS,
    payload: errorData,
  };
};


export const redirectToStep = (step, history, nextStep) => {
  nextStep = constants.SECTION_STEPS[nextStep];  // eslint-disable-line

  return () => {
    if (nextStep && step !== 'step-8' && step !== 'step-9') {
      history.replace({
        pathname: formatRoute(routes.COMPLETE_PROFILE, { step: nextStep }),
      });
    } else {
      window.location.reload();
    }
  };
};


export const updateFiles = (files = []) => {
  return {
    type: actionTypes.UPDATE_FILES,
    payload: files,
  };
};


export const getSectionData = (section, token, inputs, history, siteId, editMode = false) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    let url = `/profiles/complete-profile/${section}?site_id=${siteId}`;
    if (editMode) {
      url = `/profiles/edit-profile/${section}?site_id=${siteId}`;
    }

    const step = constants.SECTION_STEPS[section];

    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        if (!response.data.slug && step !== 'step-8' && step !== 'step-9') {
          const updatedControls = {};

          Object.keys(response.data).map((key) => {
            const input = { ...inputs[key] };
            if (input.type) {
              const validity = checkValidity(response.data[key], input.validation);
              input.value = response.data[key];
              input.valid = validity.isValid;
              input.errorMsg = validity.errorMsg;
              updatedControls[key] = input;
            }
            return null;
          });
          dispatch(updateBranchFieldStatus(response.data.hide_branch));
          dispatch(updateProfileInputs(section, updatedControls));
        } else if (!response.data.slug && (step === 'step-8' || step === 'step-9')) {
          dispatch(updateFiles(response.data.files));
        } else if (!editMode) {
          dispatch(redirectToStep(step, history, response.data.slug));
        }
        dispatch(toggleLoading());
      })
      .catch((error) => {
        dispatch(toggleLoading());
        dispatch(manageAuthActionError(error, token));
      });
  };
};


export const inputChangedHandler = (event, field, section, inputs) => {
  return (dispatch) => {
    const updatedControls = changeInputHandler(
      event,
      inputs,
      field,
    );
    dispatch(updateProfileInputs(section, updatedControls));
  };
};


const formatSectionData = (section, fieldData) => {
  let fields = { ...fieldData };

  if (section === 'basicinfo') {
    if (fields.bureau) {
      fields.bureau = fields.bureau.value;
    }
  }
  if (section === 'personalinfo') {
    let birthDate = new Date(fields.birth_date);
    birthDate = `${birthDate.getFullYear()}-${birthDate.getMonth() + 1}-${birthDate.getDate()}`;
    fields.birth_date = birthDate;
    let birthTime = new Date(fields.birth_time);
    birthTime = `${birthTime.getHours()}:${birthTime.getMinutes()}`;
    fields.birth_time = birthTime;
    fields.birth_place = fields.birth_place.value;
    fields.caste = fields.caste.value;
    fields.marital_status = fields.marital_status.value;
  }
  if (section === 'lifestyleinfo') {
    fields.body_type = fields.body_type.value;
    fields.diet = fields.diet.value;
    fields.smoke = fields.smoke.value;
    fields.drink = fields.drink.value;
  }
  if (section === 'educationinfo') {
    fields.qualification = fields.qualification.value;
    fields.profession = fields.profession.value;
    const degree = [...fields.degree];
    const qs = [];
    for (const q in degree) {
      qs.push(degree[q].value);
    }
    fields.degree = qs;
    fields.work_profile = fields.work_profile.value;
    fields.income = fields.income.value;
  }
  if (section === 'familyinfo') {
    fields.father_occupation = fields.father_occupation.value;
    fields.mother_occupation = fields.mother_occupation.value;
  }
  if (section === 'contactinfo') {
    fields.self_city = fields.self_city.value;
    fields.family_city = fields.family_city.value;
    fields.residence_type = fields.residence_type.value;
  }
  if (section === 'photos' || section === 'pdfs') {
    const data = new FormData();
    data.append('file', fields.file);
    fields = data;
  }
  if (section === 'partnerchoice') {
    const marital = [...fields.marital_status];
    const ms = [];
    for (const m in marital) {
      ms.push(marital[m].value);
    }
    fields.marital_status = ms;

    const caste = [...fields.caste];
    const cs = [];
    for (const c in caste) {
      cs.push(caste[c].value);
    }
    fields.caste = cs;

    const qualification = [...fields.qualification];
    const ql = [];
    for (const q in qualification) {
      ql.push(qualification[q].value);
    }
    fields.qualification = ql;

    const degree = [...fields.degree];
    const degrees = [];
    for (const d in degree) {
      degrees.push(degree[d].value);
    }
    fields.degree = degrees;

    const profession = [...fields.profession];
    const ps = [];
    for (const p in profession) {
      ps.push(profession[p].value);
    }
    fields.profession = ps;

    const workProfile = [...fields.work_profile];
    const wps = [];
    for (const w in workProfile) {
      wps.push(workProfile[w].value);
    }
    fields.work_profile = wps;

    const income = [...fields.income];
    const ins = [];
    for (const i in income) {
      ins.push(income[i].value);
    }
    fields.income = ins;

    const country = [...fields.country];
    const cnt = [];
    for (const cn in country) {
      cnt.push(country[cn].value);
    }
    fields.country = cnt;

    if (fields.diet) {
      fields.diet = fields.diet.value;
    }
    if (fields.smoke) {
      fields.smoke = fields.smoke.value;
    }
    if (fields.drink) {
      fields.drink = fields.drink.value;
    }
  }
  return fields;
};


export const showSuccessMsg = (msg) => {
  return {
    type: actionTypes.SHOW_SUCCESS_MESSAGE,
    payload: msg,
  };
};


export const submitHandler = (event, section, inputs, token, history, siteId, editMode = false) => {
  return (dispatch) => {
    dispatch(toggleLoading());

    const result = handleFormSubmit(event, inputs);
    const step = constants.SECTION_STEPS[section];

    if (result.formError) {
      // frontend error
      dispatch(toggleError());
      dispatch(updateProfileInputs(section, result.inputs));
      dispatch(toggleLoading());
    }

    // no errors in frontend validation.. go ahead and axios it.
    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const fields = formatSectionData(section, result.fields);

      let url = `/profiles/complete-profile/${section}?site_id=${siteId}`;
      if (editMode) {
        url = `/profiles/edit-profile/${section}?site_id=${siteId}`;
      }

      if (section === 'deleteProfile') {
        url = '/profiles/delete-profile';
      }
      axios.post(url, fields, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          if (section === 'deleteProfile') {
            window.location.href = '/';
          }
          if (editMode) {
            dispatch(showSuccessMsg('Your profile has been updated!'));
            dispatch(getSectionData(section, token, inputs, history, siteId, true));
            dispatch(storeUserData(response.data.user));
            dispatch(storeAuthData({
              token: token,  // eslint-disable-line
              user: response.data.user,
            }));
          } else {
            dispatch(redirectToStep(step, history, response.data.next_step));
          }
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(toggleError());
          dispatch(updateFieldErrors(step, inputs, error.response.data));
          if (section === 'deleteProfile') {
            window.location.href = '/';
          }
          if (error.response && error.response.data && error.response.data.non_field_errors) {
            dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
          }
        });
    }
  };
};


export const deleteFile = (fileID, token, editMode) => {
  return (dispatch) => {
    if (confirm('Are you sure you want to do this?')) {  // eslint-disable-line
      dispatch(toggleLoading());
      const url = '/profiles/delete-file';
      axios.post(url, { file_id: fileID }, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          if (editMode) {
            dispatch(storeUserData(response.data.user));
            dispatch(storeAuthData({
              token: token,  // eslint-disable-line
              user: response.data.user,
            }));
          }
          window.location.reload();
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(updateNonFieldErrors(error.response.data.non_field_errors));
        });
    }
  };
};


export const onUnmount = () => {
  return {
    type: actionTypes.PROFILE_UNMOUNT,
  };
};


export const showProfileStatus = (data) => {
  return {
    type: actionTypes.SHOW_PROFILE_STATUS,
    payload: data,
  };
};


export const getProfileStatus = (token) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = '/profiles/status';
    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(storeUserData(response.data.user));
        dispatch(storeAuthData({
          token: token,  // eslint-disable-line
          user: response.data.user,
        }));
        dispatch(showProfileStatus(response.data));
      })
      .catch((error) => {
        dispatch(toggleLoading());
        dispatch(manageAuthActionError(error, token));
      });
  };
};


export const showProfileError = (error) => {
  return {
    type: actionTypes.SHOW_PROFILE_ERROR,
    payload: error,
  };
};

export const showProfile = (data) => {
  return {
    type: actionTypes.SHOW_PROFILE,
    payload: data,
  };
};


export const getProfile = (token, slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = `/profiles/view-profile/${slug}`;
    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        dispatch(showProfile(response.data));
        dispatch(toggleLoading());
      })
      .catch((error) => {
        try {
          dispatch(manageAuthActionError(error, token));
        } catch (err) {
          dispatch(showProfileError('Something went wrong! Please contact support!'));
        }
        dispatch(toggleLoading());
      });
  };
};


export const setAvatar = (fileID, token) => {
  return (dispatch) => {
    if (confirm('Are you sure you want to do this?')) {  // eslint-disable-line
      dispatch(toggleLoading());
      const url = '/profiles/set-avatar';
      axios.post(url, { file_id: fileID }, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          dispatch(storeUserData(response.data.user));
          dispatch(storeAuthData({
            token: token,  // eslint-disable-line
            user: response.data.user,
          }));
          window.location.reload();
        })
        .catch((error) => {
          dispatch(toggleLoading());
          dispatch(updateNonFieldErrors(error.response.data.details));
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/profile/actions.js